import { observer } from "mobx-react-lite";
import { ContextProps } from "@menu/core/types";
import { AnalyticsType, determineIfLoggedIn, getAnalyticTags } from "@menu/core/lib";

const SignOut = observer((props: ContextProps) => {
    const context = props.context;
    const dictionary = context.dictionary;

    //This strange logic !context.config.hideProfile is the same as the original version.
    //It's a hacky way of hiding the sign out button if you're signed in as there should be
    //a profile menu with a sign out link. Ideally there should be an extra config property to
    //handle this logic.
    if (!context.config.hideProfile || !context.isLoggedIn) {
        return null;
    }

    const url = context.authService.getSignOutUrl();

    const analyticTags = getAnalyticTags({
        component_name: "signout_click",
        nav_item: AnalyticsType.topLevel,
        nav_text: "sign_out",
        target_page_url: url
    });

    const onClick = () => {
        context.authService.signOut();
        determineIfLoggedIn(context);
    }

    return (<span className="sign-out"
        {...analyticTags}
        onClick={onClick}>{dictionary.signOut}</span>);
});

export default SignOut;